import { Controller } from 'stimulus';

export default class extends Controller {
    connect() {
        let that = this;

        if (this.isForm()) {
            this.element.addEventListener('change', function () {
                that.formIsChanged();
            })

            this.element.addEventListener('submit', function () {
                that.allowFormSubmission();
            })
        }

        this.setChanged("false");
    }

    formIsChanged(event) {
        this.setChanged("true")
    }

    leavingPage(event) {
        if (this.isFormChanged()) {
            if (event.type == "turbolinks:before-visit") {
                if (!window.confirm(unsaved_alert_message)) {
                    event.preventDefault()
                }
            } else {
                event.returnValue = unsaved_alert_message;
                return event.returnValue;
            }
        }
    }

    allowFormSubmission(event) {
        this.setChanged("false")
    }

    setChanged(changed) {
        this.data.set("changed", changed)
    }

    isFormChanged() {
        return this.data.get("changed") === "true";
    }

    isForm() {
        return this.element.nodeName === "FORM";
    }

    changeTab(event) {
        const form = this.element.querySelector('form');

        const isChanged = this.isForm() ? this.isFormChanged() : form.dataset.unsavedChangesChanged === "true";
        if (isChanged) {
            if (!confirm(unsaved_alert_message)) {
                event.preventDefault();
                event.stopPropagation();
                event.cancelBubble = true;
            } else {
                this.isForm() ? this.setChanged("false") : form.dataset.unsavedChangesChanged = 'false';
            }
        }
    }
}